import React, { useEffect, useState, useMemo } from "react";
import trash from "../../../../../assets/restaurant/images/trash.svg";

import {
  LOADER_TIMEOUT_TIME,
  ORDER_MANAGEMENT_STATUS,
  PAYMENT_OPTIONS,
  PAYMENT_STATUS,
  SORT_A,
  SORT_D,
  SWAL_SETTINGS,
} from "../../../../../utils/Constants";

import Swal from "sweetalert2";
import { useFormik } from "formik";
import { useValidationSchemas } from "../../../validator/validation";
import { useTranslation } from "react-i18next";
import {
  capitalizeFirstLetter,
  formateDate,
  globalLoader,
  handleOffcanvasScroll,
  handleServerValidations,
  removeSpacesAndCharacters,
  removeSpecialCharacter,
  RSUITE_DATE_FORMAT,
  TrimText,
  useDebouncing,
  writeMyExcel,
} from "../../../../../utils/commonfunction";
import CustomError from "../../../../../utils/customError";
import RecordNotFound from "../../../shared/recordNotFound";
import TableActionDropdown from "../../../shared/components/TableActionDropdown";
import Skeleton from "react-loading-skeleton";
import logo from "../../../../../assets/restaurant/images/calenderLogo.png";
import * as Yup from "yup";
import { DatePicker, Drawer } from "rsuite";
import isBefore from "date-fns/isBefore";
import {
  addPayment,
  deletePaymentManagament,
  editPaymentManagament,
  paymentDetails,
  paymentListApi,
  paymentOrderOption,
  paymentVendorOption,
} from "../../../services/payment-managament.service";
import { deleteOrder } from "../../../services/order-management.service";

const CustomBase64Caret = () => (
  <img src={logo} alt="Custom Caret" style={{ width: 20, height: 20 }} />
);

const ITEMS_PER_PAGE = 10;

// ✅ Simple Pagination Component - arrows + page numbers
const SimplePagination = ({ currentPage, totalRecords, itemsPerPage, onPageChange }) => {
  // const totalPages = Math.ceil(totalRecords / itemsPerPage);
  const totalPages = Math.ceil((Number(totalRecords) || 0) / itemsPerPage);

  if (totalPages <= 1) return null;

  // Page numbers to show (max 5)
  const getPageNumbers = () => {
    const pages = [];
    let start = Math.max(1, currentPage - 2);
    let end = Math.min(totalPages, start + 4);
    if (end - start < 4) start = Math.max(1, end - 4);
    for (let i = start; i <= end; i++) pages.push(i);
    return pages;
  };

  return (
    <ul className="pagination mb-0">
      {/* Previous Arrow */}
      <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
        <button
          className="page-link"
          onClick={() => currentPage > 1 && onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          aria-label="Previous"
        >
          {/* <span aria-hidden="true">&laquo;</span> */}
          <span
            style={{
              fontSize: "25px",
              opacity: "1.2"
            }}
            aria-hidden="true"><i className="ti ti-chevron-left"></i></span>
        </button>
      </li>

      {/* Page Numbers */}
      {getPageNumbers().map((pageNum) => (
        <li
          key={pageNum}
          className={`page-item ${currentPage === pageNum ? "active" : ""}`}
        >
          <button
            className="page-link"
            onClick={() => onPageChange(pageNum)}
          >
            {pageNum}
          </button>
        </li>
      ))}

      {/* Next Arrow */}
      <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
        <button
          className="page-link"
          onClick={() => currentPage < totalPages && onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          aria-label="Next"
        >
          <span
            style={{
              fontSize: "25px",
              opacity: "1.2"
            }}

            aria-hidden="true"><i className="ti ti-chevron-right"></i></span>
        </button>
      </li>
    </ul>
  );
};

export default function PaymentManagement() {
  const [filters, setFilters] = useState({});
  const [details, setDetails] = useState(null);
  const [loader, setLoader] = useState(false);
  const [page, setPage] = useState(1);
  const { t } = useTranslation();
  const { editOrderValidationSchema } = useValidationSchemas();
  const [refreshList, setRefreshList] = useState(false);
  const [openWithHeader, setOpenWithHeader] = useState(false);
  const [openWithHeaderEdit, setOpenWithHeaderEdit] = useState(false);
  const [vendorOptions, setVendorOptions] = useState([]);
  const [orderOptionList, setOrderOptionList] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    column: "createdAt",
    order: SORT_D,
  });
  const [addSubmissionLoader, setAddSubmissionLoader] = useState(false);
  const [editSubmissionLoader, setEditSubmissionLoader] = useState(false);
  const [detailsLoading, setDetailsLoading] = useState(true);

  // ✅ Main data states
  const [paymentListData, setPaymentListData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [offsetPage, setOffsetPage] = useState(0);

  // ✅ Search & Date filter
  const [searchValue, setSearchValue] = useState("");
  const [globalSearch, setGlobalSearch] = useState("");
  const [filterDate, setFilterDate] = useState(null);

  const prepareGlobalSearch = (value) => {
    setGlobalSearch(value);
    setPage(1);
  };
  const searchDebounce = useDebouncing(prepareGlobalSearch, 500);

  const handleSearchChange = (e) => {
    setSearchValue(e.target.value);
    searchDebounce(e.target.value);
  };

  const handleDateFilterChange = (date) => {
    setFilterDate(date);
    setPage(1);
  };

  const handleClearDateFilter = () => {
    setFilterDate(null);
    setPage(1);
  };

  // ✅ Page change handler - sirf yahi use karo
  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  // ✅ Order options fetch
  useEffect(() => {
    const formData = new FormData();
    paymentOrderOption(formData)
      .then((response) => {
        if (response?.data) {
          setOrderOptionList(response?.data?.list || []);
        }
      })
      .catch((error) => {
        console.log("Order list error ====> ", error);
      });
  }, []);

  useEffect(() => {
    setLoader(true);
    const formData = new FormData();
    if (Object.keys(searchValue).length || Object.keys(filters).length) {
      formData.append("searchValue", JSON.stringify({ ...searchValue, ...filters }));
    }
    formData.append("global_search", globalSearch);
    formData.append("page", page);
    formData.append("per_page", ITEMS_PER_PAGE);
    if (sortConfig) formData.append("sort", JSON.stringify(sortConfig));


    paymentListApi(formData)
      .then((response) => {
        if (response?.data) {
          setPaymentListData(response.data.list || []);
          setTotalRecords(response.data.total_records || 0);
          setOffsetPage(response.data.offset || 0);
        } else {
          setPaymentListData([]);
          setTotalRecords(0);
          setOffsetPage(0);
        }
        setTimeout(() => setLoader(false), LOADER_TIMEOUT_TIME);
      })
      .catch((error) => {
        console.log("API Error ===>", error);
        setPaymentListData([]);
        setTotalRecords(0);
        setLoader(false);
      });
  }, [page, globalSearch, sortConfig, refreshList, filters]);

  const formatOrderId = (id) => {
    if (!id) return "-";
    const lastSix = id.slice(-6);
    return parseInt(lastSix, 16);
  };

  // ✅ Client-side date filter
  const displayData = useMemo(() => {
    if (!filterDate) return paymentListData;

    const selectedDate = new Date(filterDate);
    selectedDate.setHours(0, 0, 0, 0);

    return paymentListData.filter((item) => {
      if (!item?.payment_date) return false;
      const itemDate = new Date(item.payment_date);
      itemDate.setHours(0, 0, 0, 0);
      return itemDate.getTime() === selectedDate.getTime();
    });
  }, [paymentListData, filterDate]);

  const handleViewDetails = async (item) => {
    try {
      setDetailsLoading(true);
      const response = await paymentDetails({ o_id: item._id });
      if (response.success) {
        setDetails(response?.data);
      }
      setDetailsLoading(false);
    } catch (err) {
      console.error(err);
      setDetailsLoading(false);
    }
  };

  const addPaymentValidationSchema = Yup.object().shape({
    order_id: Yup.string().required("Order is required"),
    payment_date: Yup.date().required("Payment date is required"),
    payment_method: Yup.string().required("Payment method is required"),
    payment_status: Yup.string().required("Payment status is required"),
  });

  const editPaymentValidationSchema = Yup.object().shape({
    order_id: Yup.string().required("Order is required"),
    payment_date: Yup.date().required("Payment date is required"),
    payment_method: Yup.string().required("Payment method is required"),
    payment_status: Yup.string().required("Payment status is required"),
  });

  const handleEditDetails = async (item) => {
    try {
      setDetailsLoading(true);
      const response = await paymentDetails({ o_id: item._id });
      if (response.success) {
        const data = response?.data;

        if (data?.order_id) {
          const formData = new FormData();
          formData.append("order_id", data.order_id);
          paymentVendorOption(formData)
            .then((res) => {
              const vendors = Array.isArray(res.data) ? res.data : [res.data];
              setVendorOptions(vendors);
              if (vendors.length > 0) {
                editForm.setFieldValue("vendor_id", data.vendor_id || vendors[0].vendor_id?.toString());
              }
            })
            .catch((err) => console.error("Error fetching vendor options:", err));
        }

        editForm.setValues({
          _id: data?._id,
          order_id: data?.order_id || "",
          payment_date: data?.payment_date || "",
          payment_amount: data?.payment_amount || "",
          payment_status: data?.payment_status || "",
          payment_method: data?.payment_method || "",
          content_and_notes: data?.content_and_notes || "",
          vendor_id: data?.vendor_id || "",
        });
      }
      setDetailsLoading(false);
    } catch (err) {
      console.error(err);
      setDetailsLoading(false);
    }
  };

  const deletePaymentRecord = async (item) => {
    Swal.fire({
      title: t("msg_are_you_sure"),
      text: t("btn_delete_text"),
      imageUrl: trash,
      showCancelButton: true,
      confirmButtonColor: "#dc3545",
      cancelButtonColor: "#6c757d",
      confirmButtonText: t("btn_delete"),
      cancelButtonText: t("btn_cancel"),
      reverseButtons: true,
      customClass: {
        popup: "swal-restaurant",
        confirmButton: "btn btn-danger col",
        cancelButton: "btn btn-secondary col",
      },
      allowOutsideClick: false,
    }).then(async (result) => {
      if (result.isConfirmed) {
        globalLoader(true);
        let relatedOrderId = item.order_id;
 
        try {
          if (!relatedOrderId) {
            const detailRes = await paymentDetails({ o_id: item._id });
            if (detailRes && detailRes.success && detailRes.data) {
              relatedOrderId = detailRes.data.order_id;
            }
          }

          const response = await deletePaymentManagament({ p_id: item._id });

          if (response.success) {
            if (relatedOrderId) {
              try {
                await deleteOrder({ o_id: relatedOrderId });
              } catch (err) {
                console.error("deleteOrderError", err);
              }
            }
            globalLoader(false);
            Swal.fire({ icon: "success", text: response.message, ...SWAL_SETTINGS });
            setRefreshList((prev) => !prev);
          } else {
            globalLoader(false);
            Swal.fire({ icon: "error", text: handleServerValidations(response), ...SWAL_SETTINGS });
          }
        } catch (error) {
          globalLoader(false);
          console.error("deletePaymentError", error);
        }
      }
    });
  };


  const addForm = useFormik({
    initialValues: {
      vendor_id: "",
      order_id: "",
      payment_date: "",
      payment_amount: "",
      content_and_notes: "",
      payment_method: "",
      payment_status: "",
    },
    validationSchema: addPaymentValidationSchema,
    enableReinitialize: true,
    onSubmit: (values, { resetForm }) => {
      const formData = new FormData();
      formData.append("vender_id", values.vendor_id);
      formData.append("order_id", values.order_id);
      formData.append("payment_date", values.payment_date);
      formData.append("payment_amount", values.payment_amount);
      formData.append("content_and_notes", values.content_and_notes);
      formData.append("payment_method", values.payment_method);
      formData.append("payment_status", values.payment_status);
      setAddSubmissionLoader(true);
      addPayment(formData)
        .then((response) => {
          setAddSubmissionLoader(false);
          if (response.success) {
            Swal.fire({ icon: "success", text: response.message, ...SWAL_SETTINGS });
            resetForm();
            setPage(1);
            setOpenWithHeader(false);
            setRefreshList(!refreshList);
            setSortConfig({ column: "createdAt", order: SORT_D });
          } else {
            Swal.fire({ icon: "error", text: handleServerValidations(response), ...SWAL_SETTINGS });
          }
        })
        .catch((error) => {
          setAddSubmissionLoader(false);
          console.error("Error adding payment", error);
        });
    },
  });

  // ✅ Edit Form
  const editForm = useFormik({
    initialValues: {
      _id: "",
      vendor_id: "",
      order_id: "",
      payment_date: "",
      payment_amount: "",
      content_and_notes: "",
      payment_method: "",
      payment_status: "",
    },
    validationSchema: editPaymentValidationSchema,
    validateOnChange: true,
    validateOnBlur: true,
    enableReinitialize: true,
    onSubmit: (values) => {
      setEditSubmissionLoader(true);
      const formData = new FormData();
      formData.append("_id", values._id);
      formData.append("vendor_id", values.vendor_id);
      formData.append("order_id", values.order_id);
      formData.append("payment_date", values.payment_date);
      formData.append("payment_amount", values.payment_amount);
      formData.append("content_and_notes", values.content_and_notes);
      formData.append("payment_method", values.payment_method);
      formData.append("payment_status", values.payment_status);
      editPaymentManagament(formData)
        .then((response) => {
          setEditSubmissionLoader(false);
          if (response.success) {
            Swal.fire({ icon: "success", text: response.message, ...SWAL_SETTINGS });
            setOpenWithHeaderEdit(false);
            setRefreshList(!refreshList);
          } else {
            Swal.fire({ icon: "error", text: handleServerValidations(response), ...SWAL_SETTINGS });
          }
        })
        .catch((error) => {
          setEditSubmissionLoader(false);
          console.error("Error updating payment", error);
        });
    },
  });

  const handleOrderExportToExcel = () => {
    if (!paymentListData || paymentListData.length === 0) return;
    const headers = [
      t("label_company_name"),
      t("label_notes"),
      t("label_payment_amount"),
      t("label_payment_status"),
      t("label_payment_date"),
      t("label_payment_method"),
    ];

    const rows = paymentListData.map((item) => [
      item?.companyName || "-",
      item?.content_and_notes ? item?.content_and_notes : "-",
      item?.payment_amount ? item?.payment_amount : "-",
      item?.payment_status ? item?.payment_status : "-",
      item?.payment_date ? formateDate(item.payment_date) : "-",
      item?.payment_method ? item?.payment_method : "-",
    ]);
    writeMyExcel([headers, ...rows], `${t("label_payment_list")}.xlsx`);
  };

  const vendnorOptionHandler = (orderId, formInstance = addForm) => {
    const formData = new FormData();
    formData.append("order_id", orderId);
    paymentVendorOption(formData)
      .then((response) => {
        const vendors = Array.isArray(response.data) ? response.data : [response.data];
        setVendorOptions(vendors);
        if (vendors.length > 0) {
          formInstance.setFieldValue("vendor_id", vendors[0].vendor_id?.toString());
          formInstance.setFieldValue("payment_amount", vendors[0].order_amount || "");
        }
      })
      .catch((error) => console.error("Error fetching vendor options:", error));
  };

  const formatPaymentLabel = (value) => {
    if (!value) return "";
    if (value.toLowerCase() === "upi") return "UPI";
    return value
      .toLowerCase()
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const handleSort = (key) => {
    let direction = SORT_A;
    if (sortConfig.column === key && sortConfig.order === SORT_A) {
      direction = SORT_D;
    }
    setSortConfig({ column: key, order: direction });
    setPage(1);
  };


  const showingCount =
    totalRecords > 0
      ? Math.min(page * ITEMS_PER_PAGE, totalRecords)
      : 0;

  return (
    <main id="main-content">
      <div className="inner-container">
        <div className="page-header d-flex align-items-center">
          <h4 className="heading-title-text">{t("label_payment_management")}</h4>
        </div>

        <div className="card-outer-header d-flex justify-content-between align-items-center mb-4">
          <div className="search-box">
            <input
              type="text"
              value={searchValue}
              className="form-control search-input"
              placeholder={t("input_placeholder_search")}
              onChange={handleSearchChange}
            />
          </div>
          <div className="card-head-group d-flex align-items-center gap-2">
            <div style={{ position: "relative", display: "inline-flex", alignItems: "center" }}>
              <DatePicker
                oneTap={true}
                classPrefix="restaurant"
                placeholder={t("label_date_range")}
                placement="autoVertical"
                format={RSUITE_DATE_FORMAT}
                cleanable={true}
                editable={false}
                value={filterDate ? new Date(filterDate) : null}
                onChange={handleDateFilterChange}
                onClean={handleClearDateFilter}
                caretAs={CustomBase64Caret}
              />
            </div>

            <button className="btn btn-primary" onClick={() => setOpenWithHeader(true)}>
              <i className="ti ti-plus"></i> {t("label_payment_registration")}
            </button>

            <button
              className="btn btn-primary"
              style={{ whiteSpace: "nowrap" }}
              onClick={handleOrderExportToExcel}
              disabled={paymentListData.length === 0}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14 3V7C14 7.26522 14.1054 7.51957 14.2929 7.70711C14.4804 7.89464 14.7348 8 15 8H19M14 3H7C6.46957 3 5.96086 3.21071 5.58579 3.58579C5.21071 3.96086 5 4.46957 5 5V19C5 19.5304 5.21071 20.0391 5.58579 20.4142C5.96086 20.7893 6.46957 21 7 21H11.5M14 3L19 8M19 8V13M14 19H21M21 19L18 16M21 19L18 22" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>{" "}
              {t("label_export")}
            </button>
          </div>
        </div>

        <div className="page-header d-flex align-items-center">
          <h6 className="heading-title-text">{t("label_payment_history")}</h6>
        </div>

        <div className="dashboard-content-wraper">
          <div className="category-list-wrap">
            {loader ? (
              <div className="w-100">
                <Skeleton className="mb-2" height={50} count={5} />
              </div>
            ) : displayData?.length ? (
              <div className="card">
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>
                            {t("label_order_id")}
                            <span style={{ cursor: "pointer" }} onClick={() => handleSort("orderId")}>
                              <i className={`${sortConfig.column === "orderId" && sortConfig.order === SORT_D ? "sort-disabled" : ""}`} style={{ marginLeft: "5px" }}></i>
                            </span>
                          </th>
                          <th>
                            {t("label_company_name")}
                            <span style={{ cursor: "pointer" }} onClick={() => handleSort("companyName")}>
                              <i className={`${sortConfig.column === "companyName" && sortConfig.order === SORT_D ? "sort-disabled" : ""}`} style={{ marginLeft: "5px" }}></i>
                            </span>
                          </th>
                          <th>{t("label_payment_notes")}</th>
                          <th>{t("title_payment_amount")}</th>
                          <th>{t("label_payment_status")}</th>
                          <th>{t("label_payment_date")}</th>
                          <th style={{ width: "150px" }}>{t("label_payment_method")}</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {displayData.map((item) => (
                          <tr key={item._id}>
                            <td>#{formatOrderId(item._id)}</td>
                            <td>{capitalizeFirstLetter(TrimText(item?.companyName, 20)) || "-"}</td>
                            <td>{capitalizeFirstLetter(TrimText(item?.content_and_notes)) || "-"}</td>
                            <td>¥{item?.payment_amount || 0}</td>
                            <td>
                              {item?.payment_status === "paid" ? (
                                <span className="status-badge d-block status-badge-success" style={{ width: "max-content" }}>
                                  {t("label_paid")}
                                </span>
                              ) : (
                                <span className="status-badge d-block status-badge-danger" style={{ width: "max-content" }}>
                                  {t("label_unpaid")}
                                </span>
                              )}
                            </td>
                            <td>
                              {item?.payment_date ? formateDate(item.payment_date) : "-"}
                            </td>
                            <td>{formatPaymentLabel(item?.payment_method) || "-"}</td>
                            <td className="">
                              <TableActionDropdown>
                                  <li>
                                    <a
                                      className="dropdown-item cp"
                                      onClick={() => handleViewDetails(item)}
                                      data-bs-toggle="offcanvas"
                                      data-bs-target="#view-staff"
                                    >
                                      <i className="ti ti-eye"></i>
                                      {t("btn_view")}
                                    </a>
                                  </li>
                                  <li>
                                    <a className="dropdown-item cp" onClick={() => { handleEditDetails(item); setOpenWithHeaderEdit(true); }}>
                                      <i className="ti ti-edit"></i> {t("btn_edit")}
                                    </a>
                                  </li>
                                  <li>
                                    <a className="dropdown-item cp text-danger" onClick={() => deletePaymentRecord(item)}>
                                      <i className="ti ti-trash"></i> {t("btn_delete")}
                                    </a>
                                  </li>
                              </TableActionDropdown>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  {/* ✅ FIXED PAGINATION - arrows properly kaam karenge */}
                  <div className="table-status-info d-flex justify-content-between align-items-center">
                    <span>
                      {t("label_showing_entries", { shown: showingCount, total: totalRecords })}
                    </span>
                    <nav aria-label="Page navigation example">
                      <SimplePagination
                        currentPage={page}
                        totalRecords={totalRecords}
                        itemsPerPage={ITEMS_PER_PAGE}
                        onPageChange={handlePageChange}
                      />
                    </nav>
                  </div>
                </div>
              </div>
            ) : (
              <RecordNotFound heading="no_payment_found" />
            )}
          </div>
        </div>
      </div>

      {/* Add Payment Drawer */}
      <Drawer open={openWithHeader}>
        <Drawer.Header closeButton={false}>
          <div className="d-flex justify-content-between w-100 align-items-center">
            <h5 className="mb-0">{t("label_payment_registration")}</h5>
            <button className="btn-icon" onClick={() => { setOpenWithHeader(false); addForm.resetForm(); }}>
              <i className="ri-close-fill"></i>
            </button>
          </div>
        </Drawer.Header>
        <Drawer.Body onScroll={(e) => handleOffcanvasScroll(e, "editNewEmail", "rsuite")}>
          <form onSubmit={addForm.handleSubmit}>
            <div className="mb-3">
              <label className="form-label">{t("label_order_vendor")}</label>
              <select
                className="form-control"
                name="vendor_id"
                value={addForm.values.vendor_id}
                onChange={addForm.handleChange}
                onBlur={addForm.handleBlur}
                disabled
              >
                <option value="">{t("input_select_vender_a_text")}</option>
                {Array.isArray(vendorOptions) && vendorOptions.length > 0 ? (
                  vendorOptions.map((vendor) => (
                    <option key={vendor.vendor_id} value={vendor.vendor_id}>
                      {vendor.companyName}
                    </option>
                  ))
                ) : (
                  <option>{t("no_vendors_found")}</option>
                )}
              </select>
            </div>

            <div className="mb-3">
              <label className="form-label">{t("label_order")}</label>

              <select
                className="form-control"
                name="order_id"
                value={addForm.values.order_id}
                onChange={(e) => { vendnorOptionHandler(e.target.value); addForm.handleChange(e); }}
                onBlur={addForm.handleBlur}
              >
                <option value="">{t("placeholder_select")}</option>
                {orderOptionList?.map((order) => (
                  <option key={order._id} value={order._id}>{`#${(formatOrderId(order._id))}`}</option>
                ))}
              </select>
              <CustomError name="order_id" form={addForm} className="text-danger" />
            </div>

            <div className="mb-3">
              <label className="form-label">{t("label_payment_date")}</label>
              <DatePicker
                oneTap={true}
                classPrefix="restaurant"
                placeholder={t("placeholder_select")}
                placement="autoVertical"
                format={RSUITE_DATE_FORMAT}
                cleanable={false}
                editable={false}
                name="payment_date"
                onChange={(e) => { addForm.setFieldTouched("payment_date", true); addForm.setFieldValue("payment_date", e); }}
                value={addForm.values.payment_date ? new Date(addForm.values.payment_date) : null}
                onBlur={addForm.handleBlur}
                caretAs={CustomBase64Caret}
              />
              <CustomError name="payment_date" form={addForm} className="text-danger" />
            </div>

            <div className="mb-3">
              <label className="form-label">{t("label_payment_amount")}</label>
              <input
                type="number"
                className="form-control"
                placeholder={t("label_payment_amount")}
                name="payment_amount"
                value={addForm.values.payment_amount}
                onChange={addForm.handleChange}
                onBlur={addForm.handleBlur}
                disabled
                style={{ backgroundColor: "#f5f5f5", cursor: "not-allowed" }}
              />
            </div>

            <div className="mb-3">
              <label className="form-label">{t("label_content_and_notes")}</label>
              <textarea
                className="form-control"
                style={{ height: "120px" }}
                rows="3"
                name="content_and_notes"
                value={addForm.values.content_and_notes}
                onChange={addForm.handleChange}
                onBlur={addForm.handleBlur}
              />
              <CustomError name="content_and_notes" form={addForm} className="text-danger" />
            </div>

            <div className="mb-3">
              <label className="form-label">{t("label_payment_method")}</label>
              <select
                className="form-control"
                name="payment_method"
                value={addForm.values.payment_method}
                onChange={addForm.handleChange}
                onBlur={addForm.handleBlur}
              >
                <option value="">{t("placeholder_select")}</option>
                {Object.values(PAYMENT_OPTIONS)?.map((data) => (
                  <option key={data} value={data}>{formatPaymentLabel(data)}</option>
                ))}
              </select>
              <CustomError name="payment_method" form={addForm} className="text-danger" />
            </div>

            <div className="mb-3">
              <label className="form-label">{t("label_payment_status")}</label>
              <select
                className="form-control"
                name="payment_status"
                value={addForm.values.payment_status}
                onChange={addForm.handleChange}
                onBlur={addForm.handleBlur}
              >
                <option value="">{t("placeholder_select")}</option>
                {Object.values(PAYMENT_STATUS)?.map((data) => (
                  <option key={data} value={data}>{capitalizeFirstLetter(data)}</option>
                ))}
              </select>
              <CustomError name="payment_status" form={addForm} className="text-danger" />
            </div>

            <div className="button-form">
              <button type="submit" className={"btn btn-primary w-100" + (addSubmissionLoader ? " btn-loader" : "")}>
                {t("label_vendor_save")}
              </button>
            </div>
          </form>
        </Drawer.Body>
      </Drawer>

      {/* Edit Drawer */}
      <Drawer open={openWithHeaderEdit}>
        <Drawer.Header closeButton={false}>
          <div className="d-flex justify-content-between w-100 align-items-center">
            <h5 className="mb-0">{t("label_edit_payment_details")}</h5>
            <button className="btn-icon" onClick={() => { setOpenWithHeaderEdit(false); editForm.resetForm(); }}>
              <i className="ri-close-fill"></i>
            </button>
          </div>
        </Drawer.Header>
        <Drawer.Body>
          {detailsLoading ? (
            <Skeleton className="mb-2" height={30} count={5} />
          ) : (
            <form onSubmit={editForm.handleSubmit}>
              <div className="mb-3">
                <label className="form-label">{t("label_order_vendor")}</label>
                <select
                  className="form-control"
                  name="vendor_id"
                  value={editForm.values.vendor_id}
                  onChange={editForm.handleChange}
                  onBlur={editForm.handleBlur}
                  disabled
                >
                  <option value="">{t("input_select_vender_a_text")}</option>
                  {Array.isArray(vendorOptions) && vendorOptions.length > 0 ? (
                    vendorOptions.map((vendor) => (
                      <option key={vendor.vendor_id} value={vendor.vendor_id}>
                        {vendor?.companyName}
                      </option>
                    ))
                  ) : (
                    <option disabled>{t("no_vendors_found")}</option>
                  )}
                </select>
              </div>

              <div className="mb-3">
                <label className="form-label">{t("label_order")}</label>
                <select
                  className="form-control"
                  name="order_id"
                  value={editForm.values.order_id}
                  onChange={(e) => { vendnorOptionHandler(e.target.value, editForm); editForm.handleChange(e); }}
                  onBlur={editForm.handleBlur}
                >
                  <option value="">{t("placeholder_select")}</option>
                  {orderOptionList?.map((order) => (
                    <option key={order._id} value={order._id}>{`#${formatOrderId(order._id)}`}</option>
                  ))}
                </select>
                <CustomError name="order_id" form={editForm} className="text-danger" />
              </div>

              <div className="mb-3">
                <label className="form-label">{t("label_payment_date")}</label>
                <DatePicker
                  oneTap={true}
                  classPrefix="restaurant"
                  placeholder={t("placeholder_select")}
                  placement="autoVertical"
                  format={RSUITE_DATE_FORMAT}
                  cleanable={false}
                  editable={false}
                  name="payment_date"
                  onChange={(e) => { editForm.setFieldTouched("payment_date", true); editForm.setFieldValue("payment_date", e); }}
                  value={editForm.values.payment_date ? new Date(editForm.values.payment_date) : null}
                  onBlur={editForm.handleBlur}
                  caretAs={CustomBase64Caret}
                />
                <CustomError name="payment_date" form={editForm} className="text-danger" />
              </div>

              <div className="mb-3">
                <label className="form-label">{t("label_payment_amount")}</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder={t("label_payment_amount")}
                  name="payment_amount"
                  value={editForm.values.payment_amount}
                  onChange={editForm.handleChange}
                  onBlur={editForm.handleBlur}
                  disabled
                  style={{ backgroundColor: "#f5f5f5", cursor: "not-allowed" }}
                />
              </div>

              <div className="mb-3">
                <label className="form-label">{t("label_content_and_notes")}</label>
                <textarea
                  className="form-control"
                  style={{ height: "120px" }}
                  rows="3"
                  name="content_and_notes"
                  value={editForm.values.content_and_notes}
                  onChange={editForm.handleChange}
                  onBlur={editForm.handleBlur}
                />
                <CustomError name="content_and_notes" form={editForm} className="text-danger" />
              </div>

              <div className="mb-3">
                <label className="form-label">{t("label_payment_method")}</label>
                <select
                  className="form-control"
                  name="payment_method"
                  value={editForm.values.payment_method}
                  onChange={editForm.handleChange}
                  onBlur={editForm.handleBlur}
                >
                  <option value="">{t("placeholder_select")}</option>
                  {Object.values(PAYMENT_OPTIONS)?.map((data) => (
                    <option key={data} value={data}>{formatPaymentLabel(data)}</option>
                  ))}
                </select>
                <CustomError name="payment_method" form={editForm} className="text-danger" />
              </div>

              <div className="mb-3">
                <label className="form-label">{t("label_payment_status")}</label>
                <select
                  className="form-control"
                  name="payment_status"
                  value={editForm.values.payment_status}
                  onChange={editForm.handleChange}
                  onBlur={editForm.handleBlur}
                >
                  <option value="">{t("placeholder_select")}</option>
                  {Object.values(PAYMENT_STATUS)?.map((data) => (
                    <option key={data} value={data}>{capitalizeFirstLetter(data)}</option>
                  ))}
                </select>
                <CustomError name="payment_status" form={editForm} className="text-danger" />
              </div>

              <div className="button-form">
                <button type="submit" className={"btn btn-primary w-100" + (editSubmissionLoader ? " btn-loader" : "")}>
                  {t("btn_text_update")}
                </button>
              </div>
            </form>
          )}
        </Drawer.Body>
      </Drawer>

      {/* View Details Offcanvas */}
      <div className="offcanvas offcanvas-end right-modal-w" id="view-staff" data-bs-backdrop="static" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-modal="true" role="dialog">
        <div className="offcanvas-header">
          <h5 className="offcanvas-title">{t("payment_details")}</h5>
          <button type="button" className="btn btn-icon ms-auto" data-bs-dismiss="offcanvas" aria-label="Close">
            <i className="ti ti-x"></i>
          </button>
        </div>
        <div className="offcanvas-body">
          {detailsLoading ? (
            <Skeleton className="mb-2" height={30} count={5} />
          ) : (
            <div className="view-staff-info">
              <div className="row gap-4">
                <div className="col-md-12">
                  <h4>{t("label_order_id")}</h4>
                  <p>{details?._id ? `#${formatOrderId(details._id)}` : t("label_not_entered")}</p>
                </div>
                <div className="col-md-12">
                  <h4>{t("label_company_name_status")}</h4>
                  <p>{formatPaymentLabel(details?.companyName) || t("label_not_entered")}</p>
                </div>
                <div className="col-md-12">
                  <h4>{t("label_payment_notes")}</h4>
                  <p>{formatPaymentLabel(details?.content_and_notes) || t("label_not_entered")}</p>
                </div>
                <div className="col-md-12">
                  <h4>{t("title_payment_amount")}</h4>
                  <p>{(`¥${details?.payment_amount}`) || t("label_not_entered")}</p>
                </div>
                <div className="col-md-12">
                  <h4>{t("label_payment_date")}</h4>
                  <p>{details?.payment_date ? formateDate(details.payment_date) : t("label_not_entered")}</p>
                </div>
                <div className="col-md-12">
                  <h4>{t("label_order_payment_status")}</h4>
                  <p className="text-capitalize">{details?.paymentData?.status || details?.payment_status || "-"}</p>
                </div>
                <div className="col-md-12">
                  <h4>{t("label_choose_payment_method")}</h4>
                  <p className="text-capitalize">{formatPaymentLabel(details?.payment_method) || "-"}</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </main>
  );
}
